import { render } from "./fizjoLandingPage.vue?vue&type=template&id=0a3ef603&scoped=true"
import script from "./fizjoLandingPage.vue?vue&type=script&lang=js"
export * from "./fizjoLandingPage.vue?vue&type=script&lang=js"

import "./fizjoLandingPage.vue?vue&type=style&index=0&id=0a3ef603&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3ef603"]])

export default __exports__